import { createFileRoute } from '@tanstack/react-router';

import { StaffList } from '@/features/staff/StaffList';

export const Route = createFileRoute('/_authenticated/staff/')({
  component: StaffList,
});
